import { useEffect, useReducer } from 'react'
import { useQuery } from '../../tools/utilHooks'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { history, useTypedSelector } from '../../redux/store'
import { OrderType } from '../../tools/public'
import { usePermissionStore } from '@/stores/permission'

export const jumpStateList = ['confirm', 'stateReturn'] as const
export type jumpStateKey = keyof typeof jumpStateList
interface State {
  checkedOrderKey: OrderType
}
type ActionType = 'setCheckedOrderKey' | 'changedataAction'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedOrderKey: 'CUSTOMER',
}

const reducer = (state: State, action: Action): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'changedataAction':
      newstate = action.payload
      return newstate
    case 'setCheckedOrderKey':
      newstate.checkedOrderKey = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中订单 tab的key值
 * @param key
 * @returns
 */
const setCheckedOrderKey = (val: string): Action => ({
  type: 'setCheckedOrderKey',
  payload: val,
})

const changedataAction = (param: State): Action => ({
  type: 'changedataAction',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const query = useQuery()
  const listState = query.get('listState') || ''
  const page = query.get('page') || ''
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const permissionList = usePermissionStore((state) => state.permissionList)
  const dispatchredux = useDispatch()
  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
    } else {
      // 如果URL中有page参数，优先使用page参数
      if (page === 'SUPPLIER') {
        dispatch(setCheckedOrderKey('SUPPLIER'))
      } else if (page === 'CUSTOMER') {
        dispatch(setCheckedOrderKey('CUSTOMER'))
      } else {
        // 没有page参数时，使用原有逻辑
        if (permissionList.length === 0 || permissionList.length === 2) {
          if (jumpStateList.includes(listState as any)) {
            dispatch(setCheckedOrderKey('SUPPLIER'))
          }
        } else if (permissionList.includes('自营供应商')) {
          dispatch(setCheckedOrderKey('SUPPLIER'))
        } else {
          dispatch(setCheckedOrderKey('CUSTOMER'))
        }
      }
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: JSON.parse(JSON.stringify(state)),
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  const { checkedOrderKey } = state
  const changeOrder = (key: string) => {
    dispatch(setCheckedOrderKey(key))
  }
  return {
    changeOrder,
    checkedOrderKey,
    permissionList,
  }
}
import { useEffect, useReducer } from 'react'
import { useQuery } from '../../tools/utilHooks'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { history, useTypedSelector } from '../../redux/store'
import { OrderType } from '../../tools/public'
import { usePermissionStore } from '@/stores/permission'

export const jumpStateList = ['confirm', 'stateReturn'] as const
export type jumpStateKey = keyof typeof jumpStateList
interface State {
  checkedOrderKey: OrderType
}
type ActionType = 'setCheckedOrderKey' | 'changedataAction'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedOrderKey: 'CUSTOMER',
}

const reducer = (state: State, action: Action): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'changedataAction':
      newstate = action.payload
      return newstate
    case 'setCheckedOrderKey':
      newstate.checkedOrderKey = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中订单 tab的key值
 * @param key
 * @returns
 */
const setCheckedOrderKey = (val: string): Action => ({
  type: 'setCheckedOrderKey',
  payload: val,
})

const changedataAction = (param: State): Action => ({
  type: 'changedataAction',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const query = useQuery()
  const listState = query.get('listState') || ''
  const page = query.get('page') || ''
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const permissionList = usePermissionStore((state) => state.permissionList)
  const dispatchredux = useDispatch()
  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
    } else {
      // 如果URL中有page参数，优先使用page参数
      if (page === 'SUPPLIER') {
        dispatch(setCheckedOrderKey('SUPPLIER'))
      } else if (page === 'CUSTOMER') {
        dispatch(setCheckedOrderKey('CUSTOMER'))
      } else {
        // 没有page参数时，使用原有逻辑
        if (permissionList.length === 0 || permissionList.length === 2) {
          if (jumpStateList.includes(listState as any)) {
            dispatch(setCheckedOrderKey('SUPPLIER'))
          }
        } else if (permissionList.includes('自营供应商')) {
          dispatch(setCheckedOrderKey('SUPPLIER'))
        } else {
          dispatch(setCheckedOrderKey('CUSTOMER'))
        }
      }
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: JSON.parse(JSON.stringify(state)),
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  const { checkedOrderKey } = state
  const changeOrder = (key: string) => {
    dispatch(setCheckedOrderKey(key))
  }
  return {
    changeOrder,
    checkedOrderKey,
    permissionList,
  }
}
